// extracted by mini-css-extract-plugin
export default {"leftGroup":"HeaderLeftGroup__leftGroup--1iZJu","favoritesIcon":"HeaderLeftGroup__favoritesIcon--2UXQv","backButton":"HeaderLeftGroup__backButton--1K30o"};